<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-6">
                            <h3 class="breadcrumb-title m-0 pe-3"> <span [translate]="'GREATER.AUDIENCE'"> </span> </h3>
                        </div>
                        <div class="col-12 col-sm-6 position-relative">
                            <div class="followers-filter-box">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0);"  class="active" id="week" (click)="filters='week';getDetail()"> Week </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"  id="month" (click)="filters='month';getDetail()"> Month </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);" id="year"  (click)="filters='year';getDetail()"> Year </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->                
                <section class="inner-section-wrap dark-bg p-4" >                    
                    <div class="tab-wrap">
                        <div class="tab-header border-bottom">
                            <div class="d-flex justify-content-start">
                                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" id="pills-standard-tab" data-bs-toggle="pill" data-bs-target="#Standardtab" type="button" role="tab" aria-controls="pills-standard" aria-selected="false" (click)="types='stream';getDetail()"><span [translate]="'GREATER.STREAMS'"> </span></button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="pills-nutrition-tab" data-bs-toggle="pill" data-bs-target="#Nutritiontab" type="button" role="tab" aria-controls="pills-nutrition" aria-selected="true" (click)="types='geographical';getDetail()"><span [translate]="'GREATER.GEOGRAPHICAL'"> </span></button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="tab-content tab-content-secound" id="pills-tabContent" *ngIf="ssd">
                            <div class="tab-pane fade show active" id="Standardtab" role="tabpanel" aria-labelledby="pills-standard-tab">
                                <div class="site-content-block row pt-5">                                    
                                    <div class="col-12 col-lg-9">
                                        <div class="tab-wrap">
                                            <div class="row align-items-center pb-4">
                                                <div class="col-12" *ngIf="chartShow">
                                                    <canvas baseChart class="chart" [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType" (chartHover)="chartHovered($event)" (chartClick)="ssd=true;chartClicked($event)" > </canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            <div class="tab-pane fade" id="Nutritiontab" role="tabpanel" aria-labelledby="pills-nutrition-tab">
                                <div class="site-content-block row pt-5">                                    
                                    <div class="col-12">
                                        <div class="tab-wrap">
                                            <div class="row align-items-center pb-4">
                                                <div class="col-12 col-lg-9" *ngIf="chartShow">
                                                    <canvas baseChart class="chart" [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType" (chartHover)="chartHovered($event)" (chartClick)="ssd=true;chartClicked($event)" > </canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            <div class="row align-items-center py-4">

                                <div class="col-12 col-sm-4 py-4">
                                    <div class="followers-count-box">
                                        <p> Total this Week </p>
                                        <ul class="pt-1">
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.stream.week_counter}}</strong> &nbsp; <b>S</b>treams </li>
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.followers.week_counter}}</strong> &nbsp; <b>F</b>ollowers </li>
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.like.week_counter}}</strong> &nbsp; <b>L</b>ikes </li>
                                        </ul>
                                    </div>
                                </div>
        
                                <div class="col-12 col-sm-4 py-4">
                                    <div class="followers-count-box">
                                        <p> Total this Month </p>
                                        <ul class="pt-1">
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.stream.month_counter}}</strong> &nbsp; <b>S</b>treams </li>
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.followers.month_counter}}</strong> &nbsp; <b>F</b>ollowers </li>
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.like.month_counter}}</strong> &nbsp; <b>L</b>ikes </li>
                                        </ul>
                                    </div>
                                </div>
        
                                <div class="col-12 col-sm-4 py-4">
                                    <div class="followers-count-box">
                                        <p> Total this Year </p>
                                        <ul class="pt-1">
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.stream.year_counter}}</strong> &nbsp; <b>S</b>treams </li>
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.followers.year_counter}}</strong> &nbsp; <b>F</b>ollowers </li>
                                            <li class="font-16 py-2 font-w-300"> <strong>{{detail.like.year_counter}}</strong> &nbsp; <b>L</b>ikes </li>
                                        </ul>
                                    </div>
                                </div>
        
                            </div>
                        </div>
                    </div>
                </section>                
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</main>

